import { useCallback, useEffect, useMemo, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import { getData } from "../../../axios/apiHelper";
import { countryRegionArray } from "../../../Utils/Country";

export default function EditVwdProfile() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [type, setType] = useState("External");
  const [ibt, setIbt] = useState(false);
  const [role, setRole] = useState("");
  const [region, setRegion] = useState(null);
  const [country, setCountry] = useState("");
  const [company, setCompany] = useState("");
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await getData(`/vwd/get-user-data?uid=${state.id}`);
        if (response.status === 200) {
          const data = response?.data?.data;
          setName(data.name);
          setEmail(data.email);
          setType(data.type);
          setIbt(Boolean(data.ibt));
          setRole(data.role);
          setRegion(data.region);
          setCountry(data.country);
          setCompany(data.company);
        }
      } catch (err) {
        console.log("Error while fetching user data : ", err);
      }
    };
    if (state) {
      if (state.action === "edit") fetchUserData();
      else {
        setName(state.name);
        setEmail(state.email);
        setType(state.type);
        setIbt(Boolean(state.ibt));
        setRole(state.role);
        setRegion(state.region);
        setCountry(state.country);
        setCompany(state.company);
      }
    } 
    else navigate("/vwd/profile");
  }, [state]);

  const getCountry = useMemo(() => {
    const countryArr = [];
    Object.entries(countryRegionArray).map((entry) => {
      if (!region) countryArr.push(entry[0]);
      else if (region === entry[1]) countryArr.push(entry[0]);
    });
    return countryArr.map((c) => ({
      label: c,
      value: c,
    }));
  }, [region]);

  const getRegion = useMemo(() => {
    const uniqueRegions = new Set(Object.values(countryRegionArray));
    return Array.from(uniqueRegions).map((r) => ({
      label: r,
      value: r,
    }));
  }, []);

  const handleCancelClick = useCallback(() => {
    navigate("/vwd/profile");
  });

  const validateForm = useCallback(() => {
    const error = {};

    if (!name?.trim()) error.name = "Name is required!!";
    else error.name = null;

    if (!email?.trim()) error.email = "Email is required!!";
    else error.email = null;

    if (!["Internal", "External"].includes(type))
      error.type = "type must be among " + ["Internal", "External"].join(", ");
    else error.type = null;

    if (!role?.trim()) error.role = "Role is required!!";
    else error.role = null;

    if (!company || !company?.trim()) error.company = "Company is required!!";
    else error.company = null;

    if (!region) error.region = "Region is required!!";
    else error.region = null;

    if (!country) error.country = "Country is required!!";
    else error.country = null;
    setErrors(error);
    const err = Object.values(error).filter(v => v !== null).length;
    return err === 0 ? true : false;
  }, [name, email, type, ibt, role, company, region, country]);

  const handleNextClick = useCallback(
    (e) => {
      e.preventDefault();
      const isValid = validateForm();
      if (!isValid) return;
      navigate("/vwd/profile-review", {
        state: {
          id: state.id,
          name,
          email,
          type,
          ibt,
          role,
          company,
          region,
          country,
        },
      });
    },
    [name, email, type, ibt, role, company, region, country],
  );

  return (
    <>
      <Col className="right-sidebar custom-change">
        <div className="custom-container">
          <Row>
            <div className="page-top-nav sticky">
              <div className="row justify-content-end align-items-center">
                <Col md="1">
                  <div className="header-btn-left"></div>
                </Col>

                <Col md="9">
                  <ul className="tabnav-link">
                    <li className="active active-main">
                      <a href="">Edit Profile</a>
                    </li>
                    <li>
                      <a href="">Review &amp; approve</a>
                    </li>
                  </ul>
                </Col>

                <Col md="2">
                  <div className="header-btn">
                    <button
                      className="btn btn-primary btn-bordered move-draft"
                      onClick={handleCancelClick}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary btn-filled next"
                      onClick={handleNextClick}
                    >
                      Next
                    </button>
                  </div>
                </Col>
              </div>
            </div>

            <div className="create-reader create-change-content reader_added">
              <div className="form_action">
                <div className="create-reader-form-header">
                  <h4>User profile details</h4>
                </div>

                <div className="row">
                  <Col md="7">
                    {/* First Name */}
                    <Form.Group className="form-group">
                      <Form.Label>
                        Name <span>*</span>
                      </Form.Label>
                      <input
                        type="text"
                        placeholder="name"
                        className="form-control"
                        name="Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                      {errors.name && (
                         <div className="login-validation">
                         {errors.name}
                        </div>
                      )}
                    </Form.Group>

                    {/* Email */}
                    <Form.Group className="form-group">
                      <Form.Label>
                        Email <span>*</span>
                      </Form.Label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        value={email}
                        disabled
                      />
                      {errors.email && (
                        <div className="login-validation">
                          {errors.email}
                        </div>
                      )}
                    </Form.Group>
                    <div className="form-group">
                      <label htmlFor="">
                        Type <span>*</span>
                      </label>
                      <fieldset id="group2">
                        <input
                          type="checkbox"
                          checked={type === "Internal"}
                          name="group2"
                          id="limitagreed1"
                          disabled
                        />
                        <label htmlFor="limitagreed1">Internal</label>
                        <input
                          type="checkbox"
                          checked={type !== "Internal"}
                          name="group2"
                          id="limitagreed2"
                          disabled
                        />
                        <label htmlFor="limitagreed2">External</label>
                      </fieldset>
                      {errors.type && (
                        <div className="login-validation">
                         {errors.type}
                        </div>
                      )}
                    </div>
                    <div className="form-group">
                      <label htmlFor="">IBT</label>
                      <div className="switch">
                        <label className="switch-light">
                          <input
                            type="checkbox"
                            checked={ibt}
                            onChange={(e) => setIbt(e.target.checked)}
                          />
                          <span>
                            <span className={`switch-btn active`}>No</span>
                            <span className={`switch-btn `}>Yes</span>
                          </span>
                          <a className="btn"></a>
                        </label>
                      </div>
                    </div>
                    <Form.Group className="form-group">
                      <Form.Label>
                        Role <span>*</span>
                      </Form.Label>
                      <input
                        type="text"
                        className={`form-control${errors.company ? " error" : ""}`}
                        name="Role"
                        value={role}
                        onChange={(e) => setRole(e.target.value)}
                      />
                      {errors.role && (
                        <div className="login-validation">
                          {errors.role}
                        </div>
                      )}
                    </Form.Group>
                    <Form.Group className="form-group">
                      <Form.Label>
                        Company <span>*</span>
                      </Form.Label>

                      <input
                        type="text"
                        className={`form-control${errors.company ? " error" : ""}`}
                        name="company"
                        value={company}
                        onChange={(e) => setCompany(e.target.value)}
                      />

                      {errors.company && (
                        <div className="login-validation">
                          {errors.company}
                        </div>
                      )}
                    </Form.Group>

                    {/* Region */}
                    <Form.Group className="form-group">
                      <Form.Label>
                        Region <span>*</span>
                      </Form.Label>
                      <Select
                        className={`dropdown-basic-button split-button-dropup ${errors.region ? "error" : ""}`}
                        placeholder="Select region"
                        options={getRegion}
                        menuPlacement="top"
                        value={
                          getRegion.find((opt) => opt.value === region) || null
                        }
                        onChange={(r) => setRegion(r ? r.value : null)}
                        isClearable
                      />
                      {errors.region && (
                        <div className="login-validation">
                         {errors.region}
                        </div>
                      )}
                    </Form.Group>
                    <Form.Group className="form-group">
                      <Form.Label>
                        Country <span>*</span>
                      </Form.Label>
                      <Select
                        className={`dropdown-basic-button split-button-dropup ${errors.region ? "error" : ""}`}
                        options={getCountry}
                        placeholder="Select country"
                        value={
                          getCountry.find((opt) => opt.value === country) ||
                          null
                        }
                        onChange={(c) => setCountry(c ? c.value : null)}
                        isClearable
                        menuPlacement="top"
                      />
                      {errors.country && (
                        <div className="login-validation">
                         {errors.country}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                </div>
              </div>
            </div>
          </Row>
        </div>
      </Col>
    </>
  );
}
